
import request from '../utils/request';

// вход
export function login({ username, password }) {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  return request('/api/login', { method: 'POST', body: params });
}

export function logout() {
  return request('/api/logout');
}

export async function passwordRecoveryRequest(email) {
  return request('/api/v1/password-recovery/request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { email } ,
  });
}

export async function passwordRecoveryVerify({ token, code }) {
  return request('/api/v1/password-recovery/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: { token, code } ,
  });
}

export async function passwordRecoveryReset({ token, newPassword }) {
  return request('/api/v1/password-recovery/reset', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body:  { token, newPassword } ,
  });
}
export async function logCaseVisit(caseName) {
  return request('/api/v1/case-visits', {
    method: 'POST',
    body: { caseName },
  });
}
export async function getUserAccessAttempts(userId) {
  return request(`/api/v1/access-attempts/users/${userId}`, {
    method: 'GET',
  });
}